var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannertoplayer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 153,
    viewBox: "0 0 1440 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_12856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 153
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 153,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_12856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0048 112.982H2.71484V185.122H74.0048V112.982Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M74.0048 112.982H2.71484V185.122H74.0048V112.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.721 109.49H1V112.987H75.721V109.49Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75.721 109.49H1V112.987H75.721V109.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.0048 112.983H2.71484V114.408H74.0048V112.983Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.5127 118.004H10.8789V129.013H30.5127V118.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 119.006H11.832V120.01H15.3585V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 120.626H11.832V121.629H15.3585V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 122.245H11.832V123.248H15.3585V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 123.864H11.832V124.868H15.3585V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 125.483H11.832V126.487H15.3585V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 127.102H11.832V128.106H15.3585V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 119.006H15.835V120.01H19.3615V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 120.626H15.835V121.629H19.3615V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 122.245H15.835V123.248H19.3615V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 123.864H15.835V124.868H19.3615V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 125.483H15.835V126.487H19.3615V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 127.102H15.835V128.106H19.3615V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 119.006H21.7441V120.01H25.2706V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 120.626H21.7441V121.629H25.2706V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 122.245H21.7441V123.248H25.2706V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 123.864H21.7441V124.868H25.2706V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 125.483H21.7441V126.487H25.2706V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 127.102H21.7441V128.106H25.2706V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 119.006H25.748V120.01H29.2745V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 120.626H25.748V121.629H29.2745V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 122.245H25.748V123.248H29.2745V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 123.864H25.748V124.868H29.2745V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 125.483H25.748V126.487H29.2745V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 127.102H25.748V128.106H29.2745V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5127 129.918H10.8789V131.473H30.5127V129.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.8794 118.004H5.20898V129.013H10.8794V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 119.005H6.54297V120.008H9.54496V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 120.624H6.54297V121.627H9.54496V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 122.243H6.54297V123.246H9.54496V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 123.862H6.54297V124.866H9.54496V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 125.481H6.54297V126.485H9.54496V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 127.101H6.54297V128.104H9.54496V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.1841 118.004H30.5137V129.013H36.1841V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 119.005H31.8477V120.008H34.8496V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 120.624H31.8477V121.627H34.8496V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 122.243H31.8477V123.246H34.8496V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 123.862H31.8477V124.866H34.8496V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 125.481H31.8477V126.485H34.8496V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 127.101H31.8477V128.104H34.8496V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M65.8428 118.004H46.209V129.013H65.8428V118.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 119.006H47.1611V120.01H50.6876V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 120.626H47.1611V121.629H50.6876V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 122.245H47.1611V123.248H50.6876V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 123.864H47.1611V124.868H50.6876V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 125.483H47.1611V126.487H50.6876V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 127.102H47.1611V128.106H50.6876V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 119.006H51.1641V120.01H54.6906V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 120.626H51.1641V121.629H54.6906V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 122.245H51.1641V123.248H54.6906V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 123.864H51.1641V124.868H54.6906V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 125.483H51.1641V126.487H54.6906V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 127.102H51.1641V128.106H54.6906V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 119.006H57.0742V120.01H60.6007V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 120.626H57.0742V121.629H60.6007V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 122.245H57.0742V123.248H60.6007V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 123.864H57.0742V124.868H60.6007V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 125.483H57.0742V126.487H60.6007V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 127.102H57.0742V128.106H60.6007V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 119.006H61.0771V120.01H64.6036V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 120.626H61.0771V121.629H64.6036V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 122.245H61.0771V123.248H64.6036V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 123.864H61.0771V124.868H64.6036V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 125.483H61.0771V126.487H64.6036V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 127.102H61.0771V128.106H64.6036V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.8428 129.918H46.209V131.473H65.8428V129.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.2075 118.004H40.5371V129.013H46.2075V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 119.005H41.8711V120.008H44.8731V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 120.624H41.8711V121.627H44.8731V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 122.243H41.8711V123.246H44.8731V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 123.862H41.8711V124.866H44.8731V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 125.481H41.8711V126.485H44.8731V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 127.101H41.8711V128.104H44.8731V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.5122 118.004H65.8418V129.013H71.5122V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 119.005H67.1758V120.008H70.1778V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 120.624H67.1758V121.627H70.1778V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 122.243H67.1758V123.246H70.1778V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 123.862H67.1758V124.866H70.1778V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 125.481H67.1758V126.485H70.1778V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 127.101H67.1758V128.104H70.1778V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.5127 141.275H10.8789V152.284H30.5127V141.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 142.282H11.832V143.285H15.3585V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 143.901H11.832V144.904H15.3585V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 145.52H11.832V146.523H15.3585V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 147.139H11.832V148.143H15.3585V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 148.758H11.832V149.762H15.3585V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3585 150.378H11.832V151.381H15.3585V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 142.282H15.835V143.285H19.3615V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 143.901H15.835V144.904H19.3615V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 145.52H15.835V146.523H19.3615V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 147.139H15.835V148.143H19.3615V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 148.758H15.835V149.762H19.3615V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3615 150.378H15.835V151.381H19.3615V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 142.282H21.7441V143.285H25.2706V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 143.901H21.7441V144.904H25.2706V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 145.52H21.7441V146.523H25.2706V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 147.139H21.7441V148.143H25.2706V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 148.758H21.7441V149.762H25.2706V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2706 150.378H21.7441V151.381H25.2706V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 142.282H25.748V143.285H29.2745V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 143.901H25.748V144.904H29.2745V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 145.52H25.748V146.523H29.2745V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 147.139H25.748V148.143H29.2745V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 148.758H25.748V149.762H29.2745V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2745 150.378H25.748V151.381H29.2745V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.8794 141.275H5.20898V152.284H10.8794V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 142.282H6.54297V143.286H9.54496V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 143.895H6.54297V144.898H9.54496V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 145.514H6.54297V146.517H9.54496V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 147.133H6.54297V148.136H9.54496V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 148.752H6.54297V149.756H9.54496V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.54496 150.372H6.54297V151.375H9.54496V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.1841 141.275H30.5137V152.284H36.1841V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 142.282H31.8477V143.286H34.8496V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 143.895H31.8477V144.898H34.8496V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 145.514H31.8477V146.517H34.8496V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 147.133H31.8477V148.136H34.8496V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 148.752H31.8477V149.756H34.8496V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.8496 150.372H31.8477V151.375H34.8496V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M65.8428 141.275H46.209V152.284H65.8428V141.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 142.282H47.1611V143.285H50.6876V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 143.901H47.1611V144.904H50.6876V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 145.52H47.1611V146.523H50.6876V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 147.139H47.1611V148.143H50.6876V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 148.758H47.1611V149.762H50.6876V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.6876 150.378H47.1611V151.381H50.6876V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 142.282H51.1641V143.285H54.6906V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 143.901H51.1641V144.904H54.6906V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 145.52H51.1641V146.523H54.6906V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 147.139H51.1641V148.143H54.6906V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 148.758H51.1641V149.762H54.6906V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6906 150.378H51.1641V151.381H54.6906V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 142.282H57.0742V143.285H60.6007V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 143.901H57.0742V144.904H60.6007V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 145.52H57.0742V146.523H60.6007V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 147.139H57.0742V148.143H60.6007V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 148.758H57.0742V149.762H60.6007V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6007 150.378H57.0742V151.381H60.6007V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 142.282H61.0771V143.285H64.6036V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 143.901H61.0771V144.904H64.6036V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 145.52H61.0771V146.523H64.6036V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 147.139H61.0771V148.143H64.6036V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 148.758H61.0771V149.762H64.6036V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6036 150.378H61.0771V151.381H64.6036V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.2075 141.275H40.5371V152.284H46.2075V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 142.282H41.8711V143.286H44.8731V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 143.895H41.8711V144.898H44.8731V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 145.514H41.8711V146.517H44.8731V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 147.133H41.8711V148.136H44.8731V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 148.752H41.8711V149.756H44.8731V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.8731 150.372H41.8711V151.375H44.8731V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.5122 141.275H65.8418V152.284H71.5122V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 142.282H67.1758V143.286H70.1778V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 143.895H67.1758V144.898H70.1778V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 145.514H67.1758V146.517H70.1778V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 147.133H67.1758V148.136H70.1778V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 148.752H67.1758V149.756H70.1778V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.1778 150.372H67.1758V151.375H70.1778V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.0048 135.737H2.71484V137.292H74.0048V135.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.89 112.982H1437.18V185.122H1365.89V112.982Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1365.89 112.982H1437.18V185.122H1365.89V112.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.17 109.49H1438.89V112.987H1364.17V109.49Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1364.17 109.49H1438.89V112.987H1364.17V109.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1365.89 112.983H1437.18V114.408H1365.89V112.983Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1409.38 118.004H1429.01V129.013H1409.38V118.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 119.006H1428.06V120.01H1424.53V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 120.626H1428.06V121.629H1424.53V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 122.245H1428.06V123.248H1424.53V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 123.864H1428.06V124.868H1424.53V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 125.483H1428.06V126.487H1424.53V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 127.102H1428.06V128.106H1424.53V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 119.006H1424.06V120.01H1420.53V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 120.626H1424.06V121.629H1420.53V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 122.245H1424.06V123.248H1420.53V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 123.864H1424.06V124.868H1420.53V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 125.483H1424.06V126.487H1420.53V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 127.102H1424.06V128.106H1420.53V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 119.006H1418.15V120.01H1414.62V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 120.626H1418.15V121.629H1414.62V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 122.245H1418.15V123.248H1414.62V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 123.864H1418.15V124.868H1414.62V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 125.483H1418.15V126.487H1414.62V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 127.102H1418.15V128.106H1414.62V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 119.006H1414.14V120.01H1410.62V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 120.626H1414.14V121.629H1410.62V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 122.245H1414.14V123.248H1410.62V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 123.864H1414.14V124.868H1410.62V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 125.483H1414.14V126.487H1410.62V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 127.102H1414.14V128.106H1410.62V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1409.38 129.918H1429.01V131.473H1409.38V129.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1429.01 118.004H1434.68V129.013H1429.01V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 119.005H1433.35V120.008H1430.35V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 120.624H1433.35V121.627H1430.35V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 122.243H1433.35V123.246H1430.35V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 123.862H1433.35V124.866H1430.35V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 125.481H1433.35V126.485H1430.35V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 127.101H1433.35V128.104H1430.35V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1403.71 118.004H1409.38V129.013H1403.71V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 119.005H1408.04V120.008H1405.04V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 120.624H1408.04V121.627H1405.04V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 122.243H1408.04V123.246H1405.04V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 123.862H1408.04V124.866H1405.04V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 125.481H1408.04V126.485H1405.04V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 127.101H1408.04V128.104H1405.04V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1374.05 118.004H1393.68V129.013H1374.05V118.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 119.006H1392.73V120.01H1389.2V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 120.626H1392.73V121.629H1389.2V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 122.245H1392.73V123.248H1389.2V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 123.864H1392.73V124.868H1389.2V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 125.483H1392.73V126.487H1389.2V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 127.102H1392.73V128.106H1389.2V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 119.006H1388.73V120.01H1385.2V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 120.626H1388.73V121.629H1385.2V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 122.245H1388.73V123.248H1385.2V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 123.864H1388.73V124.868H1385.2V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 125.483H1388.73V126.487H1385.2V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 127.102H1388.73V128.106H1385.2V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 119.006H1382.82V120.01H1379.29V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 120.626H1382.82V121.629H1379.29V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 122.245H1382.82V123.248H1379.29V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 123.864H1382.82V124.868H1379.29V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 125.483H1382.82V126.487H1379.29V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 127.102H1382.82V128.106H1379.29V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 119.006H1378.82V120.01H1375.29V119.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 120.626H1378.82V121.629H1375.29V120.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 122.245H1378.82V123.248H1375.29V122.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 123.864H1378.82V124.868H1375.29V123.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 125.483H1378.82V126.487H1375.29V125.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 127.102H1378.82V128.106H1375.29V127.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1374.05 129.918H1393.68V131.473H1374.05V129.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1393.69 118.004H1399.36V129.013H1393.69V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 119.005H1398.02V120.008H1395.02V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 120.624H1398.02V121.627H1395.02V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 122.243H1398.02V123.246H1395.02V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 123.862H1398.02V124.866H1395.02V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 125.481H1398.02V126.485H1395.02V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 127.101H1398.02V128.104H1395.02V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1368.38 118.004H1374.05V129.013H1368.38V118.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 119.005H1372.72V120.008H1369.71V119.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 120.624H1372.72V121.627H1369.71V120.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 122.243H1372.72V123.246H1369.71V122.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 123.862H1372.72V124.866H1369.71V123.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 125.481H1372.72V126.485H1369.71V125.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 127.101H1372.72V128.104H1369.71V127.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1409.38 141.275H1429.01V152.284H1409.38V141.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 142.282H1428.06V143.285H1424.53V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 143.901H1428.06V144.904H1424.53V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 145.52H1428.06V146.523H1424.53V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 147.139H1428.06V148.143H1424.53V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 148.758H1428.06V149.762H1424.53V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1424.53 150.378H1428.06V151.381H1424.53V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 142.282H1424.06V143.285H1420.53V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 143.901H1424.06V144.904H1420.53V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 145.52H1424.06V146.523H1420.53V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 147.139H1424.06V148.143H1420.53V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 148.758H1424.06V149.762H1420.53V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1420.53 150.378H1424.06V151.381H1420.53V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 142.282H1418.15V143.285H1414.62V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 143.901H1418.15V144.904H1414.62V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 145.52H1418.15V146.523H1414.62V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 147.139H1418.15V148.143H1414.62V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 148.758H1418.15V149.762H1414.62V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1414.62 150.378H1418.15V151.381H1414.62V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 142.282H1414.14V143.285H1410.62V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 143.901H1414.14V144.904H1410.62V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 145.52H1414.14V146.523H1410.62V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 147.139H1414.14V148.143H1410.62V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 148.758H1414.14V149.762H1410.62V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1410.62 150.378H1414.14V151.381H1410.62V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1429.01 141.275H1434.68V152.284H1429.01V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 142.282H1433.35V143.286H1430.35V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 143.895H1433.35V144.898H1430.35V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 145.514H1433.35V146.517H1430.35V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 147.133H1433.35V148.136H1430.35V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 148.752H1433.35V149.756H1430.35V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1430.35 150.372H1433.35V151.375H1430.35V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1403.71 141.275H1409.38V152.284H1403.71V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 142.282H1408.04V143.286H1405.04V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 143.895H1408.04V144.898H1405.04V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 145.514H1408.04V146.517H1405.04V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 147.133H1408.04V148.136H1405.04V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 148.752H1408.04V149.756H1405.04V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1405.04 150.372H1408.04V151.375H1405.04V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1374.05 141.275H1393.68V152.284H1374.05V141.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 142.282H1392.73V143.285H1389.2V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 143.901H1392.73V144.904H1389.2V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 145.52H1392.73V146.523H1389.2V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 147.139H1392.73V148.143H1389.2V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 148.758H1392.73V149.762H1389.2V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1389.2 150.378H1392.73V151.381H1389.2V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 142.282H1388.73V143.285H1385.2V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 143.901H1388.73V144.904H1385.2V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 145.52H1388.73V146.523H1385.2V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 147.139H1388.73V148.143H1385.2V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 148.758H1388.73V149.762H1385.2V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.2 150.378H1388.73V151.381H1385.2V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 142.282H1382.82V143.285H1379.29V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 143.901H1382.82V144.904H1379.29V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 145.52H1382.82V146.523H1379.29V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 147.139H1382.82V148.143H1379.29V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 148.758H1382.82V149.762H1379.29V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.29 150.378H1382.82V151.381H1379.29V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 142.282H1378.82V143.285H1375.29V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 143.901H1378.82V144.904H1375.29V143.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 145.52H1378.82V146.523H1375.29V145.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 147.139H1378.82V148.143H1375.29V147.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 148.758H1378.82V149.762H1375.29V148.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1375.29 150.378H1378.82V151.381H1375.29V150.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1393.69 141.275H1399.36V152.284H1393.69V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 142.282H1398.02V143.286H1395.02V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 143.895H1398.02V144.898H1395.02V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 145.514H1398.02V146.517H1395.02V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 147.133H1398.02V148.136H1395.02V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 148.752H1398.02V149.756H1395.02V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1395.02 150.372H1398.02V151.375H1395.02V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1368.38 141.275H1374.05V152.284H1368.38V141.275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 142.282H1372.72V143.286H1369.71V142.282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 143.895H1372.72V144.898H1369.71V143.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 145.514H1372.72V146.517H1369.71V145.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 147.133H1372.72V148.136H1369.71V147.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 148.752H1372.72V149.756H1369.71V148.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1369.71 150.372H1372.72V151.375H1369.71V150.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1365.89 135.737H1437.18V137.292H1365.89V135.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.737 77.5555H75.6836V185.104H175.737V77.5555Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.737 77.5555H75.6836V185.104H175.737V77.5555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.737 75.103H75.6836V77.5572H175.737V75.103Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.737 75.103H75.6836V77.5572H175.737V75.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.737 77.5555H75.6836V79.5548H175.737V77.5555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.331 137.459H121.091V152.402H130.331V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.412 138.012H122.013V144.684H129.412V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.412 145.246H122.013V151.918H129.412V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.331 152.401H121.091V154.972H130.331V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.024 137.459H133.784V152.402H143.024V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.104 138.012H134.705V144.684H142.104V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.104 145.246H134.705V151.918H142.104V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.024 152.401H133.784V154.972H143.024V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.684 137.459H146.443V152.402H155.684V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.762 138.012H147.363V144.684H154.762V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.762 145.246H147.363V151.918H154.762V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.684 152.401H146.443V154.972H155.684V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.0753 137.459H82.835V152.402H92.0753V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1558 138.012H83.7568V144.684H91.1558V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1558 145.246H83.7568V151.918H91.1558V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.0753 152.401H82.835V154.972H92.0753V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.768 137.459H95.5273V152.402H104.768V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.848 138.012H96.4492V144.684H103.848V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.848 145.246H96.4492V151.918H103.848V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.768 152.401H95.5273V154.972H104.768V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.427 137.459H108.187V152.402H117.427V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.507 138.012H109.108V144.684H116.507V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.507 145.246H109.108V151.918H116.507V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.427 152.401H108.187V154.972H117.427V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.561 137.459H159.32V152.402H168.561V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.639 138.012H160.24V144.684H167.639V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.639 145.246H160.24V151.918H167.639V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.561 152.401H159.32V154.972H168.561V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.331 111.554H121.091V126.497H130.331V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.411 112.107H122.012V118.779H129.411V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.411 119.341H122.012V126.013H129.411V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.331 126.497H121.091V129.068H130.331V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.024 111.554H133.784V126.497H143.024V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.104 112.107H134.705V118.779H142.104V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.104 119.341H134.705V126.013H142.104V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.024 126.497H133.784V129.068H143.024V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.683 111.554H146.442V126.497H155.683V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.762 112.107H147.363V118.779H154.762V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.762 119.341H147.363V126.013H154.762V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.683 126.497H146.442V129.068H155.683V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.0753 111.554H82.835V126.497H92.0753V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1548 112.107H83.7559V118.779H91.1548V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1548 119.341H83.7559V126.013H91.1548V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.0753 126.497H82.835V129.068H92.0753V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.768 111.554H95.5273V126.497H104.768V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.848 112.107H96.4492V118.779H103.848V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.848 119.341H96.4492V126.013H103.848V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.768 126.497H95.5273V129.068H104.768V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.427 111.554H108.187V126.497H117.427V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.506 112.107H109.107V118.779H116.506V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.506 119.341H109.107V126.013H116.506V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.427 126.497H108.187V129.068H117.427V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.561 111.554H159.32V126.497H168.561V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.639 112.107H160.24V118.779H167.639V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.639 119.341H160.24V126.013H167.639V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.561 126.497H159.32V129.068H168.561V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.331 87.2274H121.091V102.17H130.331V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.411 87.7804H122.012V94.4523H129.411V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.411 95.014H122.012V101.686H129.411V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.331 102.17H121.091V104.741H130.331V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.024 87.2274H133.784V102.17H143.024V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.104 87.7804H134.705V94.4523H142.104V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.104 95.014H134.705V101.686H142.104V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.024 102.17H133.784V104.741H143.024V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.683 87.2274H146.442V102.17H155.683V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.762 87.7804H147.363V94.4523H154.762V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.762 95.014H147.363V101.686H154.762V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.683 102.17H146.442V104.741H155.683V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.0753 87.2274H82.835V102.17H92.0753V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1548 87.7804H83.7559V94.4523H91.1548V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1548 95.014H83.7559V101.686H91.1548V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.0753 102.17H82.835V104.741H92.0753V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.768 87.2274H95.5273V102.17H104.768V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.848 87.7804H96.4492V94.4523H103.848V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.848 95.014H96.4492V101.686H103.848V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.768 102.17H95.5273V104.741H104.768V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.427 87.2274H108.187V102.17H117.427V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.506 87.7804H109.107V94.4523H116.506V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.506 95.014H109.107V101.686H116.506V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.427 102.17H108.187V104.741H117.427V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.561 87.2274H159.32V102.17H168.561V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.639 87.7804H160.24V94.4523H167.639V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.639 95.014H160.24V101.686H167.639V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.561 102.17H159.32V104.741H168.561V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.16 77.5555H1364.21V185.104H1264.16V77.5555Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1264.16 77.5555H1364.21V185.104H1264.16V77.5555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.16 75.103H1364.21V77.5572H1264.16V75.103Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1264.16 75.103H1364.21V77.5572H1264.16V75.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1264.16 77.5555H1364.21V79.5548H1264.16V77.5555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1309.56 137.459H1318.8V152.402H1309.56V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1310.48 138.012H1317.88V144.684H1310.48V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1310.48 145.246H1317.88V151.918H1310.48V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1309.56 152.401H1318.8V154.972H1309.56V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1296.87 137.459H1306.11V152.402H1296.87V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1297.79 138.012H1305.19V144.684H1297.79V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1297.79 145.246H1305.19V151.918H1297.79V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1296.87 152.401H1306.11V154.972H1296.87V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1284.21 137.459H1293.45V152.402H1284.21V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1285.13 138.012H1292.53V144.684H1285.13V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1285.13 145.246H1292.53V151.918H1285.13V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1284.21 152.401H1293.45V154.972H1284.21V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1347.82 137.459H1357.06V152.402H1347.82V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1348.74 138.012H1356.14V144.684H1348.74V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1348.74 145.246H1356.14V151.918H1348.74V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1347.82 152.401H1357.06V154.972H1347.82V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1335.12 137.459H1344.37V152.402H1335.12V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1336.04 138.012H1343.44V144.684H1336.04V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1336.04 145.246H1343.44V151.918H1336.04V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1335.12 152.401H1344.37V154.972H1335.12V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1322.47 137.459H1331.71V152.402H1322.47V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1323.39 138.012H1330.78V144.684H1323.39V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1323.39 145.246H1330.78V151.918H1323.39V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1322.47 152.401H1331.71V154.972H1322.47V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1271.33 137.459H1280.57V152.402H1271.33V137.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1272.25 138.012H1279.65V144.684H1272.25V138.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1272.25 145.246H1279.65V151.918H1272.25V145.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1271.33 152.401H1280.57V154.972H1271.33V152.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1309.56 111.554H1318.8V126.497H1309.56V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1310.48 112.107H1317.88V118.779H1310.48V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1310.48 119.341H1317.88V126.013H1310.48V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1309.56 126.497H1318.8V129.068H1309.56V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1296.87 111.554H1306.11V126.497H1296.87V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1297.79 112.107H1305.19V118.779H1297.79V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1297.79 119.341H1305.19V126.013H1297.79V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1296.87 126.497H1306.11V129.068H1296.87V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1284.21 111.554H1293.45V126.497H1284.21V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1285.13 112.107H1292.53V118.779H1285.13V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1285.13 119.341H1292.53V126.013H1285.13V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1284.21 126.497H1293.45V129.068H1284.21V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1347.82 111.554H1357.06V126.497H1347.82V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1348.74 112.107H1356.14V118.779H1348.74V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1348.74 119.341H1356.14V126.013H1348.74V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1347.82 126.497H1357.06V129.068H1347.82V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1335.12 111.554H1344.37V126.497H1335.12V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1336.04 112.107H1343.44V118.779H1336.04V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1336.04 119.341H1343.44V126.013H1336.04V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1335.12 126.497H1344.37V129.068H1335.12V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1322.47 111.554H1331.71V126.497H1322.47V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1323.39 112.107H1330.79V118.779H1323.39V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1323.39 119.341H1330.79V126.013H1323.39V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1322.47 126.497H1331.71V129.068H1322.47V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1271.33 111.554H1280.57V126.497H1271.33V111.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1272.25 112.107H1279.65V118.779H1272.25V112.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1272.25 119.341H1279.65V126.013H1272.25V119.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1271.33 126.497H1280.57V129.068H1271.33V126.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1309.56 87.2274H1318.8V102.17H1309.56V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1310.48 87.7804H1317.88V94.4523H1310.48V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1310.48 95.014H1317.88V101.686H1310.48V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1309.56 102.17H1318.8V104.741H1309.56V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1296.87 87.2274H1306.11V102.17H1296.87V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1297.79 87.7804H1305.19V94.4523H1297.79V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1297.79 95.014H1305.19V101.686H1297.79V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1296.87 102.17H1306.11V104.741H1296.87V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1284.21 87.2274H1293.45V102.17H1284.21V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1285.13 87.7804H1292.53V94.4523H1285.13V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1285.13 95.014H1292.53V101.686H1285.13V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1284.21 102.17H1293.45V104.741H1284.21V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1347.82 87.2274H1357.06V102.17H1347.82V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1348.74 87.7804H1356.14V94.4523H1348.74V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1348.74 95.014H1356.14V101.686H1348.74V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1347.82 102.17H1357.06V104.741H1347.82V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1335.12 87.2274H1344.37V102.17H1335.12V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1336.04 87.7804H1343.44V94.4523H1336.04V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1336.04 95.014H1343.44V101.686H1336.04V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1335.12 102.17H1344.37V104.741H1335.12V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1322.47 87.2274H1331.71V102.17H1322.47V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1323.39 87.7804H1330.79V94.4523H1323.39V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1323.39 95.014H1330.79V101.686H1323.39V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1322.47 102.17H1331.71V104.741H1322.47V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1271.33 87.2274H1280.57V102.17H1271.33V87.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1272.25 87.7804H1279.65V94.4523H1272.25V87.7804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1272.25 95.014H1279.65V101.686H1272.25V95.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1271.33 102.17H1280.57V104.741H1271.33V102.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.526 112.87H177.27V184.977H248.526V112.87Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M248.526 112.87H177.27V184.977H248.526V112.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.242 109.378H175.556V112.874H250.242V109.378Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M250.242 109.378H175.556V112.874H250.242V109.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.527 112.872H177.271V114.296H248.527V112.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.527 135.613H177.271V137.167H248.527V135.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M195.4 117.883H184.002V128.887H195.4V117.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 118.884H185.367V119.887H189.483V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 120.503H185.367V121.506H189.483V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 122.122H185.367V123.126H189.483V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 123.741H185.367V124.745H189.483V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 125.354H185.367V126.357H189.483V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 126.973H185.367V127.976H189.483V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 118.884H189.918V119.887H194.033V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 120.503H189.918V121.506H194.033V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 122.122H189.918V123.126H194.033V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 123.741H189.918V124.745H194.033V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 125.354H189.918V126.357H194.033V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 126.973H189.918V127.976H194.033V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M241.797 117.883H230.399V128.887H241.797V117.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 118.884H231.765V119.887H235.88V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 120.503H231.765V121.506H235.88V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 122.122H231.765V123.126H235.88V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 123.741H231.765V124.745H235.88V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 125.354H231.765V126.357H235.88V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 126.973H231.765V127.976H235.88V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 118.884H236.316V119.887H240.432V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 120.503H236.316V121.506H240.432V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 122.122H236.316V123.126H240.432V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 123.741H236.316V124.745H240.432V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 125.354H236.316V126.357H240.432V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 126.973H236.316V127.976H240.432V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M218.598 117.883H207.2V128.887H218.598V117.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 118.884H208.565V119.887H212.681V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 120.503H208.565V121.506H212.681V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 122.122H208.565V123.126H212.681V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 123.741H208.565V124.745H212.681V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 125.354H208.565V126.357H212.681V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 126.973H208.565V127.976H212.681V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 118.884H213.117V119.887H217.233V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 120.503H213.117V121.506H217.233V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 122.122H213.117V123.126H217.233V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 123.741H213.117V124.745H217.233V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 125.354H213.117V126.357H217.233V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 126.973H213.117V127.976H217.233V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M195.4 141.448H184.002V152.452H195.4V141.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 142.45H185.367V143.453H189.483V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 144.069H185.367V145.072H189.483V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 145.688H185.367V146.692H189.483V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 147.307H185.367V148.311H189.483V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 148.92H185.367V149.923H189.483V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.483 150.539H185.367V151.543H189.483V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 142.45H189.918V143.453H194.033V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 144.069H189.918V145.072H194.033V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 145.688H189.918V146.692H194.033V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 147.307H189.918V148.311H194.033V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 148.92H189.918V149.923H194.033V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.033 150.539H189.918V151.543H194.033V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M241.797 141.448H230.399V152.452H241.797V141.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 142.45H231.765V143.453H235.88V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 144.069H231.765V145.072H235.88V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 145.688H231.765V146.692H235.88V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 147.307H231.765V148.311H235.88V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 148.92H231.765V149.923H235.88V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.88 150.539H231.765V151.543H235.88V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 142.45H236.316V143.453H240.432V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 144.069H236.316V145.072H240.432V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 145.688H236.316V146.692H240.432V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 147.307H236.316V148.311H240.432V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 148.92H236.316V149.923H240.432V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.432 150.539H236.316V151.543H240.432V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M218.598 141.448H207.2V152.452H218.598V141.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 142.45H208.565V143.453H212.681V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 144.069H208.565V145.072H212.681V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 145.688H208.565V146.692H212.681V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 147.307H208.565V148.311H212.681V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 148.92H208.565V149.923H212.681V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.681 150.539H208.565V151.543H212.681V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 142.45H213.117V143.453H217.233V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 144.069H213.117V145.072H217.233V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 145.688H213.117V146.692H217.233V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 147.307H213.117V148.311H217.233V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 148.92H213.117V149.923H217.233V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.233 150.539H213.117V151.543H217.233V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.527 136.864H177.271V137.166H248.527V136.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.37 112.87H1262.62V184.977H1191.37V112.87Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1191.37 112.87H1262.62V184.977H1191.37V112.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.65 109.378H1264.34V112.874H1189.65V109.378Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1189.65 109.378H1264.34V112.874H1189.65V109.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1191.37 112.872H1262.62V114.296H1191.37V112.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1191.37 135.613H1262.62V137.167H1191.37V135.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1244.49 117.883H1255.89V128.887H1244.49V117.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 118.884H1254.53V119.887H1250.41V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 120.503H1254.53V121.506H1250.41V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 122.122H1254.53V123.126H1250.41V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 123.741H1254.53V124.745H1250.41V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 125.354H1254.53V126.357H1250.41V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 126.973H1254.53V127.976H1250.41V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 118.884H1249.97V119.887H1245.86V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 120.503H1249.97V121.506H1245.86V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 122.122H1249.97V123.126H1245.86V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 123.741H1249.97V124.745H1245.86V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 125.354H1249.97V126.357H1245.86V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 126.973H1249.97V127.976H1245.86V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1198.1 117.883H1209.49V128.887H1198.1V117.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 118.884H1208.13V119.887H1204.01V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 120.503H1208.13V121.506H1204.01V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 122.122H1208.13V123.126H1204.01V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 123.741H1208.13V124.745H1204.01V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 125.354H1208.13V126.357H1204.01V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 126.973H1208.13V127.976H1204.01V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 118.884H1203.58V119.887H1199.46V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 120.503H1203.58V121.506H1199.46V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 122.122H1203.58V123.126H1199.46V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 123.741H1203.58V124.745H1199.46V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 125.354H1203.58V126.357H1199.46V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 126.973H1203.58V127.976H1199.46V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1221.29 117.883H1232.69V128.887H1221.29V117.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 118.884H1231.33V119.887H1227.21V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 120.503H1231.33V121.506H1227.21V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 122.122H1231.33V123.126H1227.21V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 123.741H1231.33V124.745H1227.21V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 125.354H1231.33V126.357H1227.21V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 126.973H1231.33V127.976H1227.21V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 118.884H1226.78V119.887H1222.66V118.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 120.503H1226.78V121.506H1222.66V120.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 122.122H1226.78V123.126H1222.66V122.122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 123.741H1226.78V124.745H1222.66V123.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 125.354H1226.78V126.357H1222.66V125.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 126.973H1226.78V127.976H1222.66V126.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1244.49 141.448H1255.89V152.452H1244.49V141.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 142.45H1254.53V143.453H1250.41V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 144.069H1254.53V145.072H1250.41V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 145.688H1254.53V146.692H1250.41V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 147.307H1254.53V148.311H1250.41V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 148.92H1254.53V149.923H1250.41V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1250.41 150.539H1254.53V151.543H1250.41V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 142.45H1249.97V143.453H1245.86V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 144.069H1249.97V145.072H1245.86V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 145.688H1249.97V146.692H1245.86V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 147.307H1249.97V148.311H1245.86V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 148.92H1249.97V149.923H1245.86V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1245.86 150.539H1249.97V151.543H1245.86V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1198.1 141.448H1209.49V152.452H1198.1V141.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 142.45H1208.13V143.453H1204.01V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 144.069H1208.13V145.072H1204.01V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 145.688H1208.13V146.692H1204.01V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 147.307H1208.13V148.311H1204.01V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 148.92H1208.13V149.923H1204.01V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1204.01 150.539H1208.13V151.543H1204.01V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 142.45H1203.58V143.453H1199.46V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 144.069H1203.58V145.072H1199.46V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 145.688H1203.58V146.692H1199.46V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 147.307H1203.58V148.311H1199.46V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 148.92H1203.58V149.923H1199.46V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1199.46 150.539H1203.58V151.543H1199.46V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1221.29 141.448H1232.69V152.452H1221.29V141.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 142.45H1231.33V143.453H1227.21V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 144.069H1231.33V145.072H1227.21V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 145.688H1231.33V146.692H1227.21V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 147.307H1231.33V148.311H1227.21V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 148.92H1231.33V149.923H1227.21V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1227.21 150.539H1231.33V151.543H1227.21V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 142.45H1226.78V143.453H1222.66V142.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 144.069H1226.78V145.072H1222.66V144.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 145.688H1226.78V146.692H1222.66V145.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 147.307H1226.78V148.311H1222.66V147.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 148.92H1226.78V149.923H1222.66V148.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1222.66 150.539H1226.78V151.543H1222.66V150.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1191.37 136.864H1262.62V137.166H1191.37V136.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.781 109.569H256.811L287.484 96.1449L318.781 109.569Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M318.781 109.569H256.811L287.484 96.1449L318.781 109.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.347 113.057H252.243V185.008H323.347V113.057Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M323.347 113.057H252.243V185.008H323.347V113.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.058 109.568H250.532V111.311H325.058V109.568Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M325.058 109.568H250.532V111.311H325.058V109.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.058 111.31H250.532V113.054H325.058V111.31Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M325.058 111.31H250.532V113.054H325.058V111.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.347 113.055H252.243V114.475H323.347V113.055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.347 135.75H252.243V137.3H323.347V135.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M269.544 117.422H260.957V131.308H269.544V117.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.688 117.942H261.812V124.142H268.688V117.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.688 124.656H261.812V130.856H268.688V124.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M269.544 131.311H260.957V133.701H269.544V131.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M291.776 117.422H283.189V131.308H291.776V117.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.921 117.942H284.045V124.142H290.921V117.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.921 124.656H284.045V130.856H290.921V124.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M291.776 131.311H283.189V133.701H291.776V131.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M315.141 117.422H306.554V131.308H315.141V117.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.285 117.942H307.409V124.142H314.285V117.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.285 124.656H307.409V130.856H314.285V124.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M315.141 131.311H306.554V133.701H315.141V131.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M269.544 140.458H260.957V154.344H269.544V140.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.688 140.971H261.812V147.171H268.688V140.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.688 147.692H261.812V153.892H268.688V147.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M291.776 140.458H283.189V154.344H291.776V140.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.921 140.971H284.045V147.171H290.921V140.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.921 147.692H284.045V153.892H290.921V147.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M315.141 140.458H306.554V154.344H315.141V140.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.285 140.971H307.409V147.171H314.285V140.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.285 147.692H307.409V153.892H314.285V147.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.342 109.572H264.25L287.558 99.3705L311.342 109.572Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M304.204 109.566H271.387L287.629 102.458L304.204 109.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M264.25 109.572H271.387L287.63 102.463L304.205 109.572H311.342L287.558 99.3705L264.25 109.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.11 109.569H1183.08L1152.41 96.1449L1121.11 109.569Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1121.11 109.569H1183.08L1152.41 96.1449L1121.11 109.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.55 113.057H1187.65V185.008H1116.55V113.057Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1116.55 113.057H1187.65V185.008H1116.55V113.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.83 109.568H1189.36V111.311H1114.83V109.568Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1114.83 109.568H1189.36V111.311H1114.83V109.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.83 111.31H1189.36V113.054H1114.83V111.31Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1114.83 111.31H1189.36V113.054H1114.83V111.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1116.55 113.055H1187.65V114.475H1116.55V113.055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1116.55 135.75H1187.65V137.3H1116.55V135.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1170.35 117.422H1178.94V131.308H1170.35V117.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171.2 117.942H1178.08V124.142H1171.2V117.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171.2 124.656H1178.08V130.856H1171.2V124.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1170.35 131.311H1178.94V133.701H1170.35V131.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1148.12 117.422H1156.7V131.308H1148.12V117.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1148.97 117.942H1155.85V124.142H1148.97V117.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1148.97 124.656H1155.85V130.856H1148.97V124.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1148.12 131.311H1156.7V133.701H1148.12V131.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1124.75 117.422H1133.34V131.308H1124.75V117.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1125.61 117.942H1132.48V124.142H1125.61V117.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1125.61 124.656H1132.48V130.856H1125.61V124.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1124.75 131.311H1133.34V133.701H1124.75V131.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1170.35 140.458H1178.94V154.344H1170.35V140.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171.2 140.971H1178.08V147.171H1171.2V140.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1171.2 147.692H1178.08V153.892H1171.2V147.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1148.12 140.458H1156.7V154.344H1148.12V140.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1148.97 140.971H1155.85V147.171H1148.97V140.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1148.97 147.692H1155.85V153.892H1148.97V147.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1124.75 140.458H1133.34V154.344H1124.75V140.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1125.61 140.971H1132.48V147.171H1125.61V140.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1125.61 147.692H1132.48V153.892H1125.61V147.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.55 109.572H1175.64L1152.33 99.3705L1128.55 109.572Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1135.69 109.566H1168.51L1152.26 102.458L1135.69 109.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1175.64 109.572H1168.51L1152.26 102.463L1135.69 109.572H1128.55L1152.33 99.3705L1175.64 109.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.623 77.2991H326.426V185.002H426.623V77.2991Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M426.623 77.2991H326.426V185.002H426.623V77.2991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M426.624 77.2998H326.427V79.3025H426.624V77.2998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M393.861 137.289H384.608V152.253H393.861V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.94 137.849H385.531V144.531H392.94V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.94 145.083H385.531V151.765H392.94V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M393.861 152.251H384.608V154.826H393.861V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.841 137.289H333.587V152.253H342.841V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.92 137.849H334.51V144.531H341.92V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.92 145.083H334.51V151.764H341.92V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.841 152.251H333.587V154.826H342.841V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M368.23 137.289H358.976V152.253H368.23V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.307 137.849H359.896V144.531H367.307V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.307 145.083H359.896V151.765H367.307V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M368.23 152.251H358.976V154.826H368.23V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M419.436 137.289H410.182V152.253H419.436V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.515 137.849H411.104V144.531H418.515V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.515 145.083H411.104V151.765H418.515V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M419.436 152.251H410.182V154.826H419.436V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M393.861 111.348H384.608V126.312H393.861V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.94 111.907H385.531V118.589H392.94V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.94 119.141H385.531V125.823H392.94V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M393.861 126.312H384.608V128.887H393.861V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.841 111.348H333.587V126.312H342.841V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.92 111.907H334.51V118.589H341.92V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.92 119.141H334.51V125.823H341.92V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.841 126.312H333.587V128.887H342.841V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M368.23 111.348H358.976V126.312H368.23V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.307 111.907H359.896V118.589H367.307V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.307 119.141H359.896V125.823H367.307V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M368.23 126.312H358.976V128.887H368.23V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M419.436 111.348H410.182V126.312H419.436V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.515 111.907H411.104V118.589H418.515V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.515 119.141H411.104V125.823H418.515V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M419.436 126.312H410.182V128.887H419.436V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M393.861 87.001H384.608V101.965H393.861V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.94 87.5605H385.531V94.2425H392.94V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.94 94.7943H385.531V101.476H392.94V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M393.861 101.96H384.608V104.536H393.861V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.841 87.001H333.587V101.965H342.841V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.92 87.5605H334.51V94.2425H341.92V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.92 94.7943H334.51V101.476H341.92V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.841 101.96H333.587V104.536H342.841V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M368.23 87.001H358.976V101.965H368.23V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.307 87.5605H359.896V94.2425H367.307V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.307 94.7943H359.896V101.476H367.307V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M368.23 101.96H358.976V104.536H368.23V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M419.436 87.001H410.182V101.965H419.436V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.515 87.5605H411.104V94.2425H418.515V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.515 94.7943H411.104V101.476H418.515V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M419.436 101.96H410.182V104.536H419.436V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.892 55.2234H318.158V76.9998H434.892V55.2234Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M434.892 55.2234H318.158V76.9998H434.892V55.2234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.465 32.7546H448.268V185.003H548.465V32.7546Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M548.465 32.7546H448.268V185.003H548.465V32.7546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M548.466 32.8014H448.269V34.804H548.466V32.8014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 137.289H506.45V152.253H515.703V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 137.849H507.373V144.531H514.782V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 145.083H507.373V151.765H514.782V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 152.251H506.45V154.826H515.703V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 137.289H455.429V152.253H464.683V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 137.849H456.352V144.531H463.762V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 145.083H456.352V151.765H463.762V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 152.251H455.429V154.826H464.683V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 137.289H480.817V152.253H490.071V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 137.849H481.738V144.531H489.148V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 145.083H481.738V151.765H489.148V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 152.251H480.817V154.826H490.071V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 137.289H532.023V152.253H541.277V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 137.849H532.946V144.531H540.356V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 145.083H532.946V151.765H540.356V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 152.251H532.023V154.826H541.277V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 111.348H506.45V126.312H515.703V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 111.908H507.373V118.59H514.782V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 119.141H507.373V125.823H514.782V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 126.312H506.45V128.887H515.703V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 111.348H455.429V126.312H464.683V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 111.908H456.352V118.59H463.762V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 119.141H456.352V125.823H463.762V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 126.312H455.429V128.887H464.683V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 111.348H480.817V126.312H490.071V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 111.908H481.738V118.59H489.148V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 119.141H481.738V125.823H489.148V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 126.312H480.817V128.887H490.071V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 111.348H532.023V126.312H541.277V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 111.908H532.946V118.59H540.356V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 119.141H532.946V125.823H540.356V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 126.312H532.023V128.887H541.277V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 86.9987H506.45V101.963H515.703V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 87.558H507.373V94.24H514.782V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 94.7919H507.373V101.474H514.782V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 101.958H506.45V104.533H515.703V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 86.9987H455.429V101.963H464.683V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 87.558H456.352V94.24H463.762V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 94.7919H456.352V101.474H463.762V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 101.958H455.429V104.533H464.683V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 86.9987H480.817V101.963H490.071V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 87.558H481.738V94.24H489.148V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 94.7919H481.738V101.474H489.148V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 101.958H480.817V104.533H490.071V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 86.9987H532.023V101.963H541.277V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 87.558H532.946V94.24H540.356V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 94.7919H532.946V101.474H540.356V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 101.958H532.023V104.533H541.277V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 62.6975H506.45V77.6614H515.703V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 63.2569H507.373V69.9389H514.782V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 70.4906H507.373V77.1726H514.782V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 77.6566H506.45V80.2322H515.703V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 62.6975H455.429V77.6614H464.683V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 63.2569H456.352V69.9389H463.762V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 70.4906H456.352V77.1726H463.762V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 77.6566H455.429V80.2322H464.683V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 62.6975H480.817V77.6614H490.071V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 63.2569H481.738V69.9389H489.148V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 70.4906H481.738V77.1726H489.148V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 77.6566H480.817V80.2322H490.071V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 62.6975H532.023V77.6614H541.277V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 63.2569H532.946V69.9389H540.356V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 70.4906H532.946V77.1726H540.356V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 77.6566H532.023V80.2322H541.277V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 37.5576H506.45V52.5214H515.703V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 38.1171H507.373V44.7991H514.782V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.782 45.3509H507.373V52.0329H514.782V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.703 52.5168H506.45V55.0924H515.703V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 37.5576H455.429V52.5214H464.683V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 38.1171H456.352V44.7991H463.762V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M463.762 45.3509H456.352V52.0329H463.762V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M464.683 52.5168H455.429V55.0924H464.683V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 37.5576H480.817V52.5214H490.071V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 38.1171H481.738V44.7991H489.148V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.148 45.3509H481.738V52.0329H489.148V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.071 52.5168H480.817V55.0924H490.071V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 37.5576H532.023V52.5214H541.277V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 38.1171H532.946V44.7991H540.356V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.356 45.3509H532.946V52.0329H540.356V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.277 52.5168H532.023V55.0924H541.277V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.734 1.54626H440V32.3294H556.734V1.54626Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M556.734 1.54626H440V32.3294H556.734V1.54626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.465 32.7546H892.268V185.003H992.465V32.7546Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M992.465 32.7546H892.268V185.003H992.465V32.7546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M992.466 32.8014H892.269V34.804H992.466V32.8014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 137.289H950.45V152.253H959.703V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 137.849H951.373V144.531H958.782V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 145.083H951.373V151.765H958.782V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 152.251H950.45V154.826H959.703V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 137.289H899.429V152.253H908.683V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 137.849H900.352V144.531H907.762V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 145.083H900.352V151.765H907.762V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 152.251H899.429V154.826H908.683V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 137.289H924.817V152.253H934.071V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 137.849H925.738V144.531H933.148V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 145.083H925.738V151.765H933.148V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 152.251H924.817V154.826H934.071V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 137.289H976.023V152.253H985.277V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 137.849H976.946V144.531H984.356V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 145.083H976.946V151.765H984.356V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 152.251H976.023V154.826H985.277V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 111.348H950.45V126.312H959.703V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 111.908H951.373V118.59H958.782V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 119.141H951.373V125.823H958.782V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 126.312H950.45V128.887H959.703V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 111.348H899.429V126.312H908.683V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 111.908H900.352V118.59H907.762V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 119.141H900.352V125.823H907.762V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 126.312H899.429V128.887H908.683V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 111.348H924.817V126.312H934.071V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 111.908H925.738V118.59H933.148V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 119.141H925.738V125.823H933.148V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 126.312H924.817V128.887H934.071V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 111.348H976.023V126.312H985.277V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 111.908H976.946V118.59H984.356V111.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 119.141H976.946V125.823H984.356V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 126.312H976.023V128.887H985.277V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 86.9987H950.45V101.963H959.703V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 87.558H951.373V94.24H958.782V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 94.7919H951.373V101.474H958.782V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 101.958H950.45V104.533H959.703V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 86.9987H899.429V101.963H908.683V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 87.558H900.352V94.24H907.762V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 94.7919H900.352V101.474H907.762V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 101.958H899.429V104.533H908.683V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 86.9987H924.817V101.963H934.071V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 87.558H925.738V94.24H933.148V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 94.7919H925.738V101.474H933.148V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 101.958H924.817V104.533H934.071V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 86.9987H976.023V101.963H985.277V86.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 87.558H976.946V94.24H984.356V87.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 94.7919H976.946V101.474H984.356V94.7919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 101.958H976.023V104.533H985.277V101.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 62.6975H950.45V77.6614H959.703V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 63.2569H951.373V69.9389H958.782V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 70.4906H951.373V77.1726H958.782V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 77.6566H950.45V80.2322H959.703V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 62.6975H899.429V77.6614H908.683V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 63.2569H900.352V69.9389H907.762V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 70.4906H900.352V77.1726H907.762V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 77.6566H899.429V80.2322H908.683V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 62.6975H924.817V77.6614H934.071V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 63.2569H925.738V69.9389H933.148V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 70.4906H925.738V77.1726H933.148V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 77.6566H924.817V80.2322H934.071V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 62.6975H976.023V77.6614H985.277V62.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 63.2569H976.946V69.9389H984.356V63.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 70.4906H976.946V77.1726H984.356V70.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 77.6566H976.023V80.2322H985.277V77.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 37.5576H950.45V52.5214H959.703V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 38.1171H951.373V44.7991H958.782V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M958.782 45.3509H951.373V52.0329H958.782V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M959.703 52.5168H950.45V55.0924H959.703V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 37.5576H899.429V52.5214H908.683V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 38.1171H900.352V44.7991H907.762V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.762 45.3509H900.352V52.0329H907.762V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M908.683 52.5168H899.429V55.0924H908.683V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 37.5576H924.817V52.5214H934.071V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 38.1171H925.738V44.7991H933.148V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M933.148 45.3509H925.738V52.0329H933.148V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M934.071 52.5168H924.817V55.0924H934.071V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 37.5576H976.023V52.5214H985.277V37.5576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 38.1171H976.946V44.7991H984.356V38.1171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M984.356 45.3509H976.946V52.0329H984.356V45.3509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M985.277 52.5168H976.023V55.0924H985.277V52.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.73 1.54626H884V32.3294H1000.73V1.54626Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1000.73 1.54626H884V32.3294H1000.73V1.54626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.27 77.2991H1113.47V185.002H1013.27V77.2991Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1013.27 77.2991H1113.47V185.002H1013.27V77.2991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1013.27 77.2998H1113.47V79.3025H1013.27V77.2998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1046.03 137.289H1055.28V152.253H1046.03V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046.95 137.849H1054.36V144.531H1046.95V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046.95 145.083H1054.36V151.765H1046.95V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1046.03 152.251H1055.28V154.826H1046.03V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1097.05 137.289H1106.31V152.253H1097.05V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1097.97 137.849H1105.38V144.531H1097.97V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1097.97 145.083H1105.38V151.764H1097.97V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1097.05 152.251H1106.31V154.826H1097.05V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1071.66 137.289H1080.92V152.253H1071.66V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1072.59 137.849H1080V144.531H1072.59V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1072.59 145.083H1080V151.765H1072.59V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1071.66 152.251H1080.92V154.826H1071.66V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1020.46 137.289H1029.71V152.253H1020.46V137.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1021.38 137.849H1028.79V144.531H1021.38V137.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1021.38 145.083H1028.79V151.765H1021.38V145.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1020.46 152.251H1029.71V154.826H1020.46V152.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1046.03 111.348H1055.28V126.312H1046.03V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046.95 111.907H1054.36V118.589H1046.95V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046.95 119.141H1054.36V125.823H1046.95V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1046.03 126.312H1055.28V128.887H1046.03V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1097.05 111.348H1106.31V126.312H1097.05V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1097.97 111.907H1105.38V118.589H1097.97V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1097.97 119.141H1105.38V125.823H1097.97V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1097.05 126.312H1106.31V128.887H1097.05V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1071.66 111.348H1080.92V126.312H1071.66V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1072.59 111.907H1080V118.589H1072.59V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1072.59 119.141H1080V125.823H1072.59V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1071.66 126.312H1080.92V128.887H1071.66V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1020.46 111.348H1029.71V126.312H1020.46V111.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1021.38 111.907H1028.79V118.589H1021.38V111.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1021.38 119.141H1028.79V125.823H1021.38V119.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1020.46 126.312H1029.71V128.887H1020.46V126.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1046.03 87.001H1055.28V101.965H1046.03V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046.95 87.5605H1054.36V94.2425H1046.95V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1046.95 94.7943H1054.36V101.476H1046.95V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1046.03 101.96H1055.28V104.536H1046.03V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1097.05 87.001H1106.31V101.965H1097.05V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1097.97 87.5605H1105.38V94.2425H1097.97V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1097.97 94.7943H1105.38V101.476H1097.97V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1097.05 101.96H1106.31V104.536H1097.05V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1071.66 87.001H1080.92V101.965H1071.66V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1072.59 87.5605H1080V94.2425H1072.59V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1072.59 94.7943H1080V101.476H1072.59V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1071.66 101.96H1080.92V104.536H1071.66V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1020.46 87.001H1029.71V101.965H1020.46V87.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1021.38 87.5605H1028.79V94.2425H1021.38V87.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1021.38 94.7943H1028.79V101.476H1021.38V94.7943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1020.46 101.96H1029.71V104.536H1020.46V101.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005 55.2234H1121.73V76.9998H1005V55.2234Z",
    fill: "#C8A8FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1005 55.2234H1121.73V76.9998H1005V55.2234Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannertoplayer1);
export default __webpack_public_path__ + "static/media/bannertoplayer1.17832aeb2e4bf232eba2a36c886009c9.svg";
export { ForwardRef as ReactComponent };